const errorMessage = (state = null, action) => {
  switch (action.type) {
    case "SET_ERROR_MESSAGE":
      return action.msg;
    case "LOG_OUT":
      return null;
    default:
      return state;
  }
};

export default errorMessage;
